import { Account } from "models/Account";
import React from "react";
import { useAccountTranslation } from "../translations";
import AccountCustomerVatCheckCard from "./AccountCustomerVatCheckCard";

interface Props {
    customer: Account | null;
    onCustomerChange: (customer: Account) => void;
}

const AccountDetailCard: React.FC<Props> = ({ customer, onCustomerChange }) => {
    const { t } = useAccountTranslation();

    if (customer === null) {
        return <section className="portal-settings-section">
            <div className="portal-settings-heading">
                <span><i className="mdi mdi-domain" aria-hidden="true" /></span>
                <div><h2>{t("companyDetails")}</h2></div>
            </div>
            <div className="portal-settings-content text-muted">{t("chooseCompany")}</div>
        </section>;
    }

    const initial = customer.legal_name?.trim().slice(0, 1).toUpperCase() || "?";
    const addresses = customer.addresses ?? [];
    const address = addresses.find(candidate => candidate.primary) ?? addresses[0];

    return <section className="portal-settings-section portal-company-section">
        <div className="portal-settings-heading">
            <span><i className="mdi mdi-domain" aria-hidden="true" /></span>
            <div>
                <h2>{t("companyDetails")}</h2>
                <p>{t("companyDetailsDescription")}</p>
            </div>
        </div>
        <div className="portal-settings-content">
            <div className="portal-company-overview">
                <span className="portal-profile-avatar" aria-hidden="true">{initial}</span>
                <div className="portal-company-identity">
                    <strong>{customer.legal_name}</strong>
                    <span><i className="mdi mdi-email-outline" aria-hidden="true" />{customer.email || "—"}</span>
                </div>
                <address className="portal-company-address">
                    <span>{t("registeredAddress")}</span>
                    {address ? <>
                        <strong>{address.street} {address.number}</strong>
                        <strong>{address.postal_code} {address.city}</strong>
                        <strong>{address.country}</strong>
                    </> : <strong>—</strong>}
                </address>
            </div>
            <AccountCustomerVatCheckCard customer={customer} onCustomerChange={onCustomerChange} />
        </div>
    </section>;
};

export default AccountDetailCard;
